function dateKey(date) {
  return date.toISOString().slice(0, 10);
}

function easterSunday(year) {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  return new Date(Date.UTC(
    year,
    Math.floor((h + l - 7 * m + 114) / 31) - 1,
    (h + l - 7 * m + 114) % 31 + 1,
  ));
}

function b3HolidayKeys(year) {
  const fixed = [
    `${year}-01-01`, `${year}-01-25`, `${year}-04-21`, `${year}-05-01`,
    `${year}-07-09`, `${year}-09-07`, `${year}-10-12`, `${year}-11-02`,
    `${year}-11-15`, `${year}-11-20`, `${year}-12-24`, `${year}-12-25`,
    `${year}-12-31`,
  ];
  const easter = easterSunday(year);
  const movable = [-48, -47, -46, -2, 60].map(days => {
    const holiday = new Date(easter);
    holiday.setUTCDate(holiday.getUTCDate() + days);
    return dateKey(holiday);
  });
  return new Set([...fixed, ...movable]);
}

export function isB3TradingDay(now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Sao_Paulo',
    weekday: 'short',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(now);
  const get = type => parts.find(part => part.type === type)?.value;
  const weekday = get('weekday');
  const year = Number(get('year'));
  const currentDate = `${get('year')}-${get('month')}-${get('day')}`;
  return !['Sat', 'Sun'].includes(weekday) && !b3HolidayKeys(year).has(currentDate);
}

export function isB3MarketOpen(now = new Date()) {
  if (!isB3TradingDay(now)) return false;
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Sao_Paulo',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).formatToParts(now);
  const get = type => parts.find(part => part.type === type)?.value;
  const minutes = Number(get('hour')) * 60 + Number(get('minute'));
  return minutes >= 10 * 60 && minutes < 17 * 60;
}